import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Features } from "@/components/landing/Features";
import { AppPreview } from "@/components/landing/AppPreview";
import { InteractiveMap } from "@/components/landing/InteractiveMap";
import { ForBusiness } from "@/components/landing/ForBusiness";
import { Community } from "@/components/landing/Community";
import { MotoHub } from "@/components/landing/MotoHub";
import { Download } from "@/components/landing/Download";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative min-h-screen w-full bg-[#07090B] text-[#EAF0F6] overflow-x-hidden">
      <Navbar />
      <Hero />
      <Features />
      <AppPreview />
      <InteractiveMap />
      <ForBusiness />
      <Community />
      <MotoHub />
      <Download />
      <Footer />
    </main>
  );
}
